<script>
  import IntersectionObserver from "svelte-intersection-observer";
  import Grid from "./Grid.svelte";
  import Emoji from "@helpers/Emoji.svelte";

  let element;
  export let intersecting = false;
</script>

<IntersectionObserver {element} bind:intersecting>
  <section bind:this={element} id="outcomes">
    <div class="prose">
      <h1 class="section-title">
        Budgets should be based on <span
          class="accent-text emoji-follows"
          data-emoji="👍"
          >outcomes. <Emoji
            emoji="thumb"
            styles="top: -30%; right: -24%;"
          /></span
        >
      </h1>
      <Grid isScrollytelling={false} />
    </div>
  </section>
</IntersectionObserver>

<style>
  section {
    text-align: left;
    padding: 5rem 1rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    place-items: center;
    border: 1px solid rgba(var(--text-color-rgb), 0.25);
  }

  .emoji-follows::before {
    top: -1rem;
    right: -5rem;
  }
</style>
